export default {
  root: {
    border: 0,
    marginTop: 3,
    marginBottom: 10,
  },
  logo: {
    width: 300,
    height: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  searchBar: {
    marginTop: 6,
    width: '80%',
  },
  searchButton: {
    float: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 300,
    marginTop: 2,
  },
  searchingContainer: {
    marginTop: 5,
    display: 'flex',
    justifyContent: 'center',
  },
  tabBar: {
    marginTop: 5,
    marginBottom: 3,
  },
  noResultsLabel: {
    marginTop: 5,
    textAlign: 'center',
  },
}
